import React, { useState } from "react";
import { useSelector } from "react-redux";
import profile0 from "../../assets/profile0.jpg";
import { FormDiv } from "../common/Helpers";
import Crayon from "../iconComponents/Crayon";
import IconTick from "../iconComponents/IconTick";
import IconX from "../iconComponents/IconX";
import Addfiles from "../common/Addfiles";
import Info from "../common/Info";

export default function User(props) {

    const user = useSelector(state => state.auth.user);
    const company = useSelector(state => state.company.company);
    const isEditting = props.mode === "user-edit";
    const [crayonHovered, setCrayonHovered] = useState(false);

    const savedUserImage = user.user_icon_path && user.user_icon_path !== "undefined" ? user.user_icon_path : profile0;
    const imageSource = isEditting && props.selectedFiles.length > 0 ? profile0 : savedUserImage;

    const handleClickCrayon = (e) => {
        props.switchMode();
        setCrayonHovered(false);
    }

    return (
        <div className="gap-below-s settings" >
            <FormDiv formCondition={isEditting} onSubmit={props.handleSubmit}>
                <div className={"subhead-wrapper flex-row" + (isEditting ? " space-btwn" : "")}  >
                    <div>
                        <h2 className="title2 heavy iblock gap-right-xs">User Profile</h2>
                    </div>
                    {isEditting
                        ? <div style={{ marginTop: "-2px", marginBottom: "-2px", marginRight: "-14px" }}>
                            <button className="btn ter mini iblock gap-right-xs " disabled={props.isSubmitting} onClick={() => props.handleCancel()}>Cancel</button>
                            <button type="submit" className="btn pri iblock mini" disabled={props.isSubmitting}>{props.isSubmitting ? "Please wait..." : "Save changes"}</button>
                        </div>
                        : <button
                            onClick={(e) => handleClickCrayon(e)}
                            onMouseEnter={() => setCrayonHovered(true)}
                            onMouseLeave={() => setCrayonHovered(false)}
                        >
                            <Crayon className="iblock" height="13px" pathClass={crayonHovered ? "g1-fill" : "g6-fill"} />
                        </button>
                    }
                </div>
                <div className="table-wrapper" >
                    <div className="grid">
                        <div className="grid-child" >
                            <img className="profile" src={imageSource} />
                            {isEditting &&
                                <div className="gap-above-s">
                                    <Addfiles
                                        uploadTitle={user.user_icon_path && user.user_icon_path !== "undefined" ? "+ change picture" : "+ add picture"}
                                        attachments={undefined}
                                        selectedFiles={props.selectedFiles}
                                        handleDrop={props.handleDrop}
                                        removeSelectedFile={props.removeSelectedFile}
                                        removeUploadedFile={undefined}
                                        removedFiles={undefined}
                                        maxSize={10485760}
                                        maxFiles={1}
                                        multiple={false}
                                        accept="image/jpeg, image/png, image/jpg, image/tiff"
                                    />
                                </div>
                            }
                        </div>
                        <div className="grid-child" >
                            <h3 className="content2 heavy-grey gap-below-xxs">About</h3>
                            {isEditting
                                ? <div className="inputs-wrapper">
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="first_name"
                                            id="first_name"
                                            value={props.newUserInfo.first_name ? props.newUserInfo.first_name : ""}
                                            onChange={(e) => props.handleChange(e)}
                                            required
                                        />
                                        <label htmlFor="first_name">First Name<span> *</span></label>
                                    </div>
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="last_name"
                                            id="last_name"
                                            value={props.newUserInfo.last_name ? props.newUserInfo.last_name : ""}
                                            onChange={(e) => props.handleChange(e)}
                                            required
                                        />
                                        <label htmlFor="last_name">Last Name<span> *</span></label>
                                    </div>
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="job_title"
                                            id="job_title"
                                            value={props.newUserInfo.job_title ? props.newUserInfo.job_title : ""}
                                            onChange={(e) => props.handleChange(e)}
                                        />
                                        <label htmlFor="job_title">Job title</label>
                                    </div>
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="phone_number"
                                            id="phone_number"
                                            value={props.newUserInfo.phone_number ? props.newUserInfo.phone_number : ""}
                                            onChange={(e) => props.handleChange(e)}
                                        />
                                        <label htmlFor="phone_number">Phone Number</label>
                                    </div>
                                </div>
                                : <>
                                    <h4 className="content1 multiline heavy">{user.first_name + " " + user.last_name}</h4>
                                    <h4 className="content1 multiline light-black">{user.job_title && user.job_title + " at "}{company.name}</h4>
                                    <h4 className="content1 multiline light-black">{user.email}</h4>
                                    <h4 className="content1 multiline light-black">{user.phone_number && user.phone_number}</h4>
                                </>
                            }
                        </div>
                        <div className="grid-child" style={{ gridColumn: "span 2" }}>
                            <h3 className="content2 heavy-grey gap-below-xs">Permissions</h3>
                            {user.croles["Company Admin"]
                                ? <div className="iblock">
                                    <IconTick height="12px" className="iblock gap-right-xs" pathClass="g1-fill" />
                                    <h4 className="content1 multiline light-black iblock">Super User</h4>
                                </div>
                                : <div className="iblock">
                                    <IconX height="12px" className="iblock gap-right-xs" pathClass="g7-fill" />
                                    <h4 className="content1 multiline light iblock">Super User</h4>
                                </div>
                            }
                            <Info heading="Super Users" >can admit new users into the company, and give or revoke user permissions</Info>
                            <div>
                                {user.croles["Creator"]
                                    ? <div className="iblock">
                                        <IconTick height="12px" className="iblock gap-right-xs" pathClass="g1-fill" />
                                        <h4 className="content1 multiline light-black iblock">Editor</h4>
                                    </div>
                                    : <div className="iblock">
                                        <IconX height="12px" className="iblock gap-right-xs" pathClass="g7-fill" />
                                        <h4 className="content1 multiline light iblock">Editor</h4>
                                    </div>
                                }
                                <Info heading="Editors" >can create projects & contracts on behalf of the company, and represent the company on contracts (act as Vendor Rep or Purchaser Rep)</Info>
                            </div>

                        </div>
                    </div>
                </div>
            </FormDiv>
        </div>
    )
}

